import {
  Sheet,
  SheetContent,
  SheetBody,
  SheetHeader,
  SheetTitle,
} from "@repo/ui/components/Base/Sheet";
import { Spinner } from "@repo/ui/components/Base/Spinner";
import { MeetingForm } from "./MeetingForm";
import { useGetMeeting } from "@/hooks/queryHooks/meetingHooks";
interface EditMeetingSheetProps {
  open: boolean;
  setOpen: (arg1: boolean) => void;
  tenantId: string;
  meetingId: string;
}
export const EditMeetingSheet = ({
  open,
  setOpen,
  tenantId,
  meetingId,
}: EditMeetingSheetProps) => {
  const { data: meeting } = useGetMeeting(tenantId, meetingId);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="overflow-y-scroll">
        <SheetHeader>
          {!meeting && <Spinner />}
          {meeting && (
            <div>
              <SheetTitle>{`Edit ${meeting.name}`}</SheetTitle>
              <SheetBody>
                <MeetingForm
                  meetingFormData={meeting}
                  tenantId={tenantId}
                  handleCancel={() => setOpen(false)}
                  handleComplete={() => setOpen(false)}
                  hidePreview
                />
              </SheetBody>
            </div>
          )}
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};
